function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20.894",
  height: "23.626"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_3304",
  "data-name": "Rectangle 3304",
  fill: "#ec1b3b",
  d: "M0 0h20.894v23.626H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_7102",
  "data-name": "Group 7102"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4216",
  "data-name": "Path 4216",
  d: "M15.957 12v5.522h-2.111l3.524 6.1 3.524-6.1h-2.11V12z",
  fill: "#ec1b3b"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_6962",
  "data-name": "Group 6962"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6961",
  "data-name": "Group 6961",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4217",
  "data-name": "Path 4217",
  d: "M12.113 16.522h2.843V11H18V5l-5-5H.993A.992.992 0 000 .991v18.017A1 1 0 00.993 20h13.128zM9 11.714L7.4 14H5l2.8-4L5 6h2.4L9 8.285 10.6 6H13l-2.8 4 2.8 4h-2.4z",
  fill: "#ec1b3b"
}))))));